// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__qa5rS","title":"Quiz_title__XZvVS","option":"Quiz_option__cPJbj","disable":"Quiz_disable__r-up6"};